<section class="panel-expansion">
    <mat-accordion class="appfileusersgroups" >
        <mat-expansion-panel class="mpanel" [expanded]="true" [disabled]="'true'">
            <mat-expansion-panel-header class="mpanel-header">{{'lang_file_user_permission' | language }}</mat-expansion-panel-header>
            <div class="material-panel-body">
                <div class="mbrl15 martb0">
                    <div class="row">
                        <div class="col-md-3 col-xs-12 mb-10">
                            <ng-select 
                                [items]="modules" 
                                [multiple]="false" 
                                bindLabel="module_phrase_val" 
                                bindValue="module_key" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_module_name' | language}}"
                                [(ngModel)]="module_key"
                                (change)="spinner.show();get_file_users_groups();">
                            </ng-select>
                        </div>
                        <div class="col-md-3 col-xs-12 mb-10">
                            <ng-select 
                                [items]="groups" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group_key' | language}}"
                                [(ngModel)]="group_key"
                                (change)="spinner.show();get_file_users_groups();">
                            </ng-select>
                        </div>
                        <div class="col-md-6 col-xs-12 mb-10">
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control almnabrformcontrol" (keyup)="get_file_users_groups();" [(ngModel)]="searchKey" placeholder="{{'lang_search' | language }}">
                                <span class="input-group-btn">
                                    <button class="btnSearch h34 btn btn-md btn-gray fa fa-plus mnabricon" (click)="form.reset();openModalA(fileUserGroupAction);" id="btnSearch" type="button" matTooltip="{{'lang_add' | language }}"></button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive dropdownyes customResponsive">
                                <table border="1" class="table CustomTable">
                                    <thead>
                                        <tr>
                                            <td>#</td>
                                            <td>
                                                <div class="checkbox"  matTooltip="{{'lang_check_all' | language}}">
                                                    <input type="checkbox" class="allItemsfGUlevl checkbox" id="allItemsfGUlevl" (click)="checkallItemsfGUlevl($event)"/>
                                                    <label for="checkbox"></label>
                                                </div>
                                            </td>
                                            <td>{{'lang_group_key' | language }}</td>
                                            <td>{{'lang_title' | language }}</td>
                                            <td>{{'lang_user_id' | language }}</td>
                                            <td>{{'lang_name' | language }}</td>
                                            <td>{{'lang_action' | language }}</td>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="wholeData.length != '0' " class="AppendList">
                                        <tr *ngFor="let row of tabledata; let i = index;let odd=odd; let even=even" [ngClass]="{ odd: odd, even: even }" class="makeback removerow{{row.file_users_group_id}}">
                                            <td>{{i+1}}</td>
                                            <td>
                                                <div class="checkbox" matTooltip="{{'lang_check' | language}}">
                                                    <input type="checkbox"  class="eachItemfGUlevl checkbox" value="{{row.file_users_group_id}}" (click)="checkeachItemfGUlevl($event)"/>
                                                    <label for="checkbox"></label>
                                                </div>
                                            </td>
                                            <td>{{row.group_key}}</td>
                                            <td>{{row.groupname}}</td>
                                            <td>{{row.user_id}}</td>
                                            <td>{{row.name}}</td>
                                            <td>
                                                ----
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="wholeData.length == '0' " class="AppendList">
                                        <tr class="odd">
                                            <td colspan="7" align="center">{{nodata}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="tabledata.length != '0' " class="card-footer padb0">
                    <div class="row">
                        <div *ngIf="admin" class="deleteIconDiv none col-lg-1 col-sm-6 col-6 mb-10">
                            <i class="fa fa-trash-o faicon red deleteIcon" (click)="deleteBulkDatafGUlevl();" aria-hidden="true" matTooltip="{{'lang_delete' | language }}"></i>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 mb-10">
                            {{'lang_total' | language }} : {{collectionSize}}
                        </div>
                        <div class="col-lg-5 col-sm-6 mb-10">
                            <ngb-pagination [collectionSize]="collectionSize" [maxSize]="3" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" [(page)]="page" [pageSize]="pageSize" (pageChange)="build_table_data()"></ngb-pagination>
                        </div>
                        <div class="col-lg-3 col-sm-6">
                            <select class="customselect" [(ngModel)]="pageSize" (change)="build_table_data()">
                                <option [ngValue]="10">10</option>
                                <option [ngValue]="20">20</option>
                                <option [ngValue]="50">50</option>
                                <option [ngValue]="100">100</option>
                                <option [ngValue]="250">250</option>
                                <option [ngValue]="500">500</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</section>
<ng-template #fileUserGroupAction>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">{{'lang_file_user_permission' | language }}</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="modalRefA.hide();">&times;</button>
        </div>
        <form [formGroup]="form" (ngSubmit)="submit();">
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="group_key">{{'lang_module_name' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="modules" 
                                [multiple]="false" 
                                bindLabel="module_phrase_val" 
                                bindValue="module_key" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_module_name' | language}}"
                                formControlName="module_key"
                                (change)="spinner.show();get_groups(form.get('module_key').value);">
                            </ng-select>
                            <mat-error *ngIf="form.controls['module_key'].touched && form.controls['module_key'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="form.get('module_key').value">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="level_key">{{'lang_group_key' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="formgroups" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group_key' | language}}"
                                formControlName="group_key">
                            </ng-select>
                            <mat-error *ngIf="form.controls['group_key'].touched && form.controls['group_key'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group" *ngIf="form.get('module_key').value">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="level_key">{{'lang_users' | language }} : </label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="users" 
                                [multiple]="true" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                [searchFn]="ds.customSearchFn"
                                clearAllText="Clear"
                                placeholder="{{'lang_users' | language}}"
                                formControlName="user_id"
                                (search)="search_users($event)"
                                (focus)="users = [];">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer pad15">
                <div class="row">
                    <div class="col-12 mb-10">
                        <app-alert id="default-alert"></app-alert>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-xs-12 mb-10">
                        <button type="submit" class="albutton">{{'lang_submit' | language }}</button>
                    </div>
                    <div class="col-md-6 col-xs-12 mb-10">
                        <button type="button" class="btn btn-secondary secondarybutton" data-dismiss="modal" (click)="modalRefA.hide();">{{'lang_close' | language }}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>